export const getActiveLink = (link: string, pathname: string) => {
  return pathname.includes(link);
};
